module.exports = __webpack_public_path__ + "img/UTS-grouping.a082b989.png";